import { defineStoryFunnel } from "./_story-funnel-schema";
import { BOOST_STORY_EFFECTS, buildBoostStoryOffer } from "./boost-story-shared";

export const boostEnergyStory = defineStoryFunnel({
  kind: "story-funnel",
  slug: "boost-energy-story",
  version: 2,
  effects: BOOST_STORY_EFFECTS,
  meta: { title: "Boost Energy Story" },
  offer: { href: "https://mengotomars.com/pages/boost-pdp-energy" },
  screens: [
    {
      id: "hook", role: "story", layout: "image-overlay",
      heading: "WHY ARE YOU\nSO TIRED ALL\nTHE TIME?",
      headingAccent: ["SO TIRED"],
      contentTop: 315,
      image: { src: "/static/images/story-funnels/energy-hook.webp", alt: "Man resting on a couch beside his partner", geometry: { x: -24, y: 4.64, width: 541, height: 541 }, fade: { start: 183.64, end: 537.61 } },
      blocks: [
        { type: "paragraphs", paragraphs: [
          "You used to have energy for everything. Now you reach for another coffee by 2 PM, and you\u2019re dragging through the day. By the time you get home, you've got nothing left\u2026 You blame it on work. Kids. Bills.\nStress. Life.",
          "But what if something else is stealing your energy?",
        ], emphasis: ["But what if something else is stealing your energy?"] },
        { type: "rating", stars: 5, label: "4.8/5", text: "5798 Reviews" },
      ],
      cta: "WHY DO I FEEL LIKE THIS? \u2192",
    },
    {
      id: "problem", role: "story", layout: "image-overlay",
      heading: "IT'S LIKE YOU'RE RUNNING ON EMPTY.",
      headingAccent: ["RUNNING ON EMPTY."],
      contentTop: 333,
      image: { src: "/static/images/story-funnels/energy-problem.webp", alt: "Man feeling overwhelmed at his office desk", geometry: { x: -28, y: -0.36, width: 418, height: 418 }, fade: { start: 196.64, end: 417.64 } },
      blocks: [{ type: "paragraphs", paragraphs: [
        "Every day feels like Groundhog Day\u2026",
        "Coffee barely helps you get through the workday\u2026 And when you finally get home?",
        "Your kids want to play. Your wife wants your attention. The lawn needs to be mowed\u2026\n\nBut all you want is the couch.",
        "The worst part? You work so hard to build a good life\u2026 But you're too exhausted to enjoy it.",
      ], emphasis: ["The worst part?"] }],
      cta: "FIND OUT WHAT\u2019S GOING ON \u2192",
    },
    {
      id: "testosterone", role: "story", layout: "image-overlay",
      heading: "RESPONSIBILITIES GO UP, BUT YOUR T GOES DOWN.",
      headingAccent: ["YOUR T GOES DOWN"],
      contentTop: 179,
      image: { src: "/static/images/story-funnels/energy-testosterone.webp", alt: "Man feeling overwhelmed at a kitchen table", geometry: { x: -11, y: -0.36, width: 386, height: 386, flipX: true }, fade: { start: 95.14, end: 330.64 } },
      blocks: [
        { type: "paragraphs", paragraphs: [
          "When you're younger, you work all day,\nhit the gym, stay up late, and wake up ready for more. As you age, your body starts changing.\nAround 30, testosterone levels can\ndecline by 1% per year.",
          "Testosterone is a main driver for:",
        ], emphasis: ["Testosterone is a main driver for:"] },
        { type: "list", items: [
          "\u26a1 Your energy and vitality", "\ud83e\udde0 Your mood and motivation",
          "\ud83d\udcaa Your muscle maintenance", "\ud83d\udd25 Your libido and drive",
        ] },
        { type: "paragraphs", paragraphs: ["Year after year, that decline starts to add up."] },
      ],
      cta: "WHAT CAN I DO ABOUT IT? \u2192",
    },
    {
      id: "boost-timeline", role: "story", layout: "image-overlay",
      heading: "GET YOUR ENERGY BACK. AND YOUR LIFE WITH IT.",
      headingAccent: ["ENERGY", "LIFE"],
      contentTop: 110.64,
      image: { src: "/static/images/story-funnels/energy-timeline.webp", alt: "Man training in a gym", geometry: { x: -48, y: -100.36, width: 457, height: 607 }, fade: { start: 79.64, end: 517.64 } },
      blocks: [
        { type: "paragraphs", paragraphs: [
          "Mars Men Boost supports your testosterone in four ways: MAKE MORE T, FREE YOUR T, PROTECT YOUR T, + OPTIMIZE IT.",
          "What could your next 90 days look like?",
        ], emphasis: ["What could your next 90 days look like?"], accent: ["Mars Men Boost"] },
        { type: "timeline", items: [
          { label: "\u26a1 DAY 7:", title: "IGNITION", paragraphs: ["Feel your energy and motivation coming back online."] },
          { label: "\ud83d\udd25 DAY 30:", title: "SPARK", paragraphs: ["For the first time in months, you\u2019re not dragging through the day."] },
          { label: "\ud83d\ude80 DAY 90:", title: "LIFTOFF", paragraphs: ["You're hitting the gym, showing up for your family, and still have gas left in the tank for yourself."] },
        ] },
        { type: "paragraphs", paragraphs: ["You're not working this hard just to spend\nyour life exhausted."], accent: ["You're not working this hard just to spend\nyour life exhausted."] },
      ],
      cta: "LET\u2019S SEE THE PROOF \u2192",
    },
    {
      id: "reviews", role: "story", layout: "image-overlay",
      heading: "4.78 Stars.\n503,128+ MEN\nON MARS",
      headingAccent: ["4.78", "503,128+"],
      contentTop: 186,
      image: { src: "/static/images/story-funnels/energy-reviews.webp", alt: "Man jogging beside a river at golden hour", geometry: { x: -1, y: 17.64, width: 490, height: 491 }, fade: { start: 109.14, end: 227.64 } },
      blocks: [{ type: "reviews", items: [
        {
          id: "matthew-b", rating: 5, verified: true, heading: "After 2 Years of Exhaustion, I Got My Life Back in 6 Weeks",
          paragraphs: ["\u201cWas tired of being exhausted so badly I would have to sleep for a couple of hours in addition to sleeping at night. It was no way to live. After 6 weeks. I don't feel tired anymore and can make it through the day without needing to rest. I got my life back.\u201d"],
          author: "Matthew B.",
        },
        {
          id: "samuel-g", rating: 5, verified: true, heading: "Regret Not Starting Sooner",
          paragraphs: ["\u201cI've been sleeping like a rock and waking up before my alarm, and like I was back in my 20s with my third leg pointing up lol. I've had so much energy lately is ridiculous, and I'm constantly going up on weight and muscle definitely starting to show.I'm truly satisfied and I can't imagine how better it will get. I recommend it to every man out there it will change your life\u201d"],
          author: "Samuel G.",
        },
        {
          id: "joseph-t", rating: 5, verified: true, heading: "Mid-30s and Feeling Old? Here's How I Got My 20s Energy Back",
          paragraphs: ["\u201cGreat!! I'm in my mid 30s was starting to feel sluggish and old, and tired for no reason. Been taking these for 2 months now and feeling great! With working out, my jawline is coming back. I feel like I'm in my 20s again with energy.\u201d"],
          author: "Joseph T.",
        },
        {
          id: "martin-o", rating: 5, verified: true, heading: "Dad of 5: 'Night and Day Difference'",
          paragraphs: [
            "\u201cI needed something with actual horsepower to help me keep up. I\u2019ve been on Mars Men for 2 months now, and the difference is night and day. I\u2019ve got sustained energy throughout the entire day and feel more awake and dialed-in than I have in years. No mid-afternoon wall. Just steady, reliable get-up-and-go from sunup to sundown.\u201d",
          ],
          author: "Martin O.",
        },
      ] }],
      cta: "ALRIGHT, SHOW ME THE DEAL \u2192",
    },
    buildBoostStoryOffer(),
  ],
});
